/* Copyright (C) 2019 SmartboxTv S.A. - All rights reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Erasmo Marín <emarin@smartboxtv.com>
 */

import { observable, action, flow, ObservableMap } from 'mobx';
import { generateList, generateDetail } from './actionCreator';
import fetch from '../fetch';
import ErrorsStore from './errorsStore';
import _ from '../translations';

class OrdersStore {
    constructor() {
        this.list = this.list.bind(this);
        this.detail = this.detail.bind(this);
        this.baseUrl = '/api/commerce/orders';
    }

    @observable collection = new ObservableMap();
    @observable details = new ObservableMap();

    @action
    reset = () => {
        this.collection.clear();
        this.details.clear();
    };

    @action.bound
    list = flow(function*({ hash, params } = {}) {
        return yield generateList({
            hash,
            params:{
                sortByDesc : 'expire'
            },
            url: `${this.baseUrl}/listAdminOrders`,
            store: this,
        })();
    });

    @action.bound
    detail = flow(function*({ _id = false } = {}){
        return yield generateDetail({
            _id,
            url: `${this.baseUrl}/detail/${_id}`,
            store: this,
            customError: _('There was a problem fetching the addons'),
        })();
    })
       

    @action
    changePlan = flow(function*(data) {
        try {
            const detail = yield fetch.patch({
                url: `${this.baseUrl}/upgradeAdminOrder`,
                body: {
                    data,
                },
            });
            if (detail.error) {
                ErrorsStore.addError(detail, 'Error');
            }
            return detail;
        } catch (e) {
            ErrorsStore.addError(e, 'Error ');
            console.warn(e);
            return false;
        }
    });

    @action
    cancelOrder = flow(function*(item) {
        let customError = _('There was a problem with your subscription');
        try {
            const detail = yield fetch.delete({
                url: `${this.baseUrl}/cancelAdminOrder`,
                body: { data: item },
            });
            if (detail.error) {
                ErrorsStore.addError(detail, customError);
            } else {
                ErrorsStore.addSuccess(
                    { userMessage: _('Subscription was canceled successfully') },
                    _('Operation Successfull')
                );
            }
            return detail;
        } catch (e) {
            ErrorsStore.addError(e, customError);
            console.warn(e);
            return false;
        }
    });
}
export default new OrdersStore();
